/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Button from "@mui/material/Button";
import { useCustomer } from "../../provider/Customer/CustomerProvider";
import { Box, Stack } from "@mui/material";
import ProductBox from "@/src/components/ProductBox/ProductBox";
import ProductBoxGrid from "@/src/components/ProductBoxGrid/ProductBoxGrid";
import { Link } from "react-router";

export default function CallRecordConsent() {
  const { customer } = useCustomer();

  if (!customer) {
    return null;
  }

  return (
    <ProductBox headline={"Persönliche Zusammenfassung von Beratungsgesprächen"}>
      <ProductBoxGrid
        items={[
          <Box>
            Wir bieten Ihnen den kostenlosen Service, Beratungsgespräche automatisch für Sie zusammenzufassen. Hierzu ist ein Mitschnitt des Gesprächs
            notwendig. Mit einem Klick auf “Zustimmung verwalten” können Sie Ihre Einwilligung zur Aufzeichnung von Beratungsgesprächen jederzeit erteilen oder
            widerrufen.
          </Box>,
          <Stack sx={{ height: "100%", justifyContent: "flex-end" }}>
            <Button fullWidth variant={"outlined"} component={Link} to={"/servicewelt/zustimmung-gespraechsaufzeichnung"}>
              Zustimmung verwalten
            </Button>
          </Stack>,
        ]}
      />
    </ProductBox>
  );
}
